module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_9_m.4e69f32af253407c705727fb71d0aece.png";